import { formatNumber, formatNumberWithCurrency } from '@commons/DisplayNumber';

const PROGRESS_BAR_FILL_MAX_PCT = 100;
export const STORE_NAMES_VISIBLE_COUNT = 6;

const PLACEHOLDER = '—';

const isValidMetric = (value) =>
  value !== null && value !== undefined && !Number.isNaN(value) && Number.isFinite(value);

export const formatPercentageDisplay = (value, numberDecimals) => {
  if (!isValidMetric(value)) {
    return PLACEHOLDER;
  }

  return `${formatNumber(value, numberDecimals)} %`;
};

export const formatCurrencyDisplay = (value, currency) => {
  if (!isValidMetric(value)) {
    return PLACEHOLDER;
  }

  return formatNumberWithCurrency({
    number: value,
    currency,
    displayCurrencyCode: true,
  });
};

export const formatStoreNames = (storeNames) => {
  if (!Array.isArray(storeNames) || storeNames.length === 0) {
    return { display: '', fullList: '' };
  }

  const fullList = storeNames.join(', ');

  if (storeNames.length <= STORE_NAMES_VISIBLE_COUNT) {
    return { display: fullList, fullList };
  }

  const remaining = storeNames.length - STORE_NAMES_VISIBLE_COUNT;
  const prefix = storeNames.slice(0, STORE_NAMES_VISIBLE_COUNT).join(', ');

  return {
    display: `${prefix} +${remaining}`,
    fullList,
  };
};

export const getCostBarPercentage = (cost, priceExTax, maxPriceExTax) => {
  if (!isValidMetric(cost)) {
    return 0;
  }

  if (isValidMetric(priceExTax) && priceExTax < 0) {
    return 100;
  }

  if (isValidMetric(priceExTax) && cost > priceExTax) {
    return 100;
  }

  if (!isValidMetric(maxPriceExTax) || maxPriceExTax <= 0) {
    return 100;
  }

  const percentage = (cost / maxPriceExTax) * 100;

  if (percentage < 0) {
    return 0;
  }

  if (percentage > 100) {
    return 100;
  }

  return percentage;
};

export const isCostBarOverflow = (cost, priceExTax) => {
  if (!isValidMetric(cost)) {
    return false;
  }

  if (isValidMetric(priceExTax) && priceExTax < 0) {
    return true;
  }

  return isValidMetric(priceExTax) && cost > priceExTax;
};

export const getProgressBarPercentage = (ratio) => {
  if (!isValidMetric(ratio)) {
    return 0;
  }

  if (ratio < 0) {
    return 0;
  }

  if (ratio > PROGRESS_BAR_FILL_MAX_PCT) {
    return PROGRESS_BAR_FILL_MAX_PCT;
  }

  return ratio;
};

export const isRatioOverflow = (ratio) => isValidMetric(ratio) && ratio > PROGRESS_BAR_FILL_MAX_PCT;
